import { PlainDate } from "./date";

// 2027年度 予約ルール大改定の境界日、要件共通でこの定数を参照する
// 宿泊日基準ルール（クラス制度 等）が適用される最初の宿泊日
export const RESERVATION_RULE_REVISION_2027_FIRST_APPLICABLE_NIGHT =
  PlainDate.from("2027-04-01");

// 予約操作日（現在日）基準ルール（予約開始リードタイム 等）の適用開始日
export const RESERVATION_RULE_REVISION_2027_START_DATE =
  PlainDate.from("2026-10-01");
